// @LTG-ID: F-006
// @STATUS: BUILT
// @HERMETIC: true
// @DOCS: 08_FEATURES.md#F-006, ADR-024, source_reference_v3_pending/Landing Page.html (v3) lines 1704-1738
// @CHANGED: 2026-05-24 session_005 (CHG-0076, ORCH-0073) — v3 reconciliation: extracted handlePick + ADR-024 B1 (250ms scroll to #archetype on pick, never on clear)
// @OWNER: web

import { SECTORS } from "../../data/sectors";
import { useSector } from "../../lib/use-sector";
import "./sector-selector.css";

// ADR-024 B1 — sector pick auto-scroll: 250ms delay (do not "round")
const SECTOR_PICK_SCROLL_DELAY_MS = 250;

export function SectorSelector() {
    const { sector, sectorRecord, setSector } = useSector();

    // ADR-024 B1 — sector pick auto-scrolls to #archetype after 250ms.
    // The delay lets the URL update + sector-context propagation settle so the
    // OwnerArchetype card has rendered the new sector before we scroll to it.
    // Scroll fires only when SETTING a sector — never when clearing back to null.
    function handlePick(key) {
        const next = sector === key ? null : key;
        setSector(next);
        if (next && typeof window !== "undefined") {
            window.setTimeout(() => {
                const el = document.getElementById("archetype");
                if (el) {
                    el.scrollIntoView({ behavior: "smooth", block: "start" });
                }
            }, SECTOR_PICK_SCROLL_DELAY_MS);
        }
    }

    return (
        <section
            className="ltg-block ltg-sector-block"
            id="sectors"
            data-testid="sector-selector"
        >
            <div className="ltg-container">
                <div className="ltg-block-head">
                    <span className="ltg-eyebrow">
                        Built for the business you actually run
                    </span>
                    <h2>
                        What kind of business are we valuing<em>?</em>
                    </h2>
                </div>
                <p className="ltg-sector-lede">
                    Pick your sector. We re-skin the benchmarks, vocabulary,
                    sample report and data sources to match. A plumbing company
                    and a dental practice get different multiples, different
                    deal-killer screens, and different peer comparisons. That
                    is the difference between a real CPA-grade valuation and a
                    generic online calculator.
                </p>
                <div className="ltg-sector-grid">
                    {SECTORS.map((s) => {
                        const isSelected = sector === s.key;
                        return (
                            <button
                                key={s.key}
                                type="button"
                                className={`ltg-sector-tile ${isSelected ? "is-selected" : ""}`}
                                onClick={() => handlePick(s.key)}
                                aria-pressed={isSelected}
                                data-testid={`sector-tile-${s.key}`}
                            >
                                <span className="ltg-sector-tile__icon">
                                    {s.icon}
                                </span>
                                <span className="ltg-sector-tile__label">
                                    {s.label}
                                </span>
                                <span className="ltg-sector-tile__sub">
                                    {s.sublabel}
                                </span>
                                <span
                                    className="ltg-sector-tile__check"
                                    aria-hidden="true"
                                >
                                    {isSelected ? "\u2713" : ""}
                                </span>
                            </button>
                        );
                    })}
                </div>
                {sectorRecord && (
                    <div
                        className="ltg-sector-banner"
                        data-testid="sector-active-banner"
                    >
                        <span className="ltg-sector-banner__label">
                            Now showing:{" "}
                            <strong>{sectorRecord.label}</strong>
                        </span>
                        <button
                            type="button"
                            className="ltg-sector-banner__clear"
                            onClick={() => setSector(null)}
                            data-testid="sector-active-clear"
                        >
                            Clear selection
                        </button>
                    </div>
                )}
            </div>
        </section>
    );
}

export default SectorSelector;
